import $ from 'jquery'
import Backbone from 'backbone'
import template from './all-tags.hbs'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import _ from 'lodash'
import projects from 'scoreboard/projects/projects'
import sections from 'scoreboard/components/sections'
import conductor from 'scoreboard/components/conductor'

var typeLabels = {
	'root': 'scorecards.node.scorecardRoot',
	'perspective': 'scorecards.node.perspective',
	'objective': 'scorecards.node.objective',
	'generic': 'scorecards.node.generic',
	'metric': 'scorecards.node.type.4',
	'linked': 'scorecards.node.type.5',
	'docking': 'scorecards.node.docking',
	'initiative': 'initiatives.type.0',
	'task': 'initiatives.type.1',
	'milestone': 'initiatives.type.2'
}

var AllTags = Backbone.View.extend({

	// this.options.tag is the tag the user clicked on
	// this.options.data is the array of ScorecardItemsUsingTag from the server

	className: 'all-tags',

	initialize: function(options) {
		this.options = options || {}
	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		return this
	},

	context: function() {
		const orgsById = {}
		const distinctProjects = {}
		_.each(_.get(this.options, 'data.organizations'), o => {
			orgsById[o.id] = o
			distinctProjects[o.projectId] = true
		})

		// Only show a projects column if there are 2 or more projects among the
		// tags listed (22790)
		const showProject = projects.isVisible() && _.size(distinctProjects) > 1

		var rows = _.map(this.options.data.taggedItems, ti => {
			var row = _.clone(ti)
			const org = orgsById[ti.organizationId]
			row.projectLabel = showProject && projects.get(org.projectId)
				.get('label')
			row.organizationLabel = org.label
			row.typeLabel = i18n.get(typeLabels[ti.type])
			row.overviewUrl = conductor
				.overviewUrl(sections.fromType(ti.domainType), ti.id)
			return row
		})
		return {
			showProject,
			tag: this.options.tag,
			rows: rows
		}
	}

}, {

	// so we don't have to duplicate this code
	display: function(e) {
		var tag = $(e.target).text()
		appDisplay.dialog($.post('api/tags', JSON.stringify(tag)),
			data => new AllTags({tag, data}))
	}
})

export default AllTags

AllTags.__filename__ = 'components/all-tags.js'
